/*
 * Public API Surface of ngx-gravatar
 */

export { GravatarModule } from './lib/gravatar.module';
export { GravatarConfig } from './lib/gravatar-config';
export { NgxGravatarService } from './lib/ngx-gravatar.service';
export { FALLBACK, RATING } from './lib/ngx-gravatar.enums';
